import { trim } from '@components/ArtBoard/Export/helpers'

export const normalizeString = (text?: string) => {
  return trim(text)
    ?.replace(/&/g, '&amp;')
    ?.replace(/</g, '&lt;')
    ?.replace(/>/g, '&gt;')
    ?.replace(/'/g, '&apos;')
    ?.replace(/"/g, '&quot;')
}

const capitalize = (str: string): string =>
  `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`

export const getPageNameFromPathname = (str: string): string => {
  const parts = str.split('/').filter(Boolean)
  const lastPart = parts[parts.length - 1]

  if (!lastPart) {
    return 'Home'
  }

  return capitalize(lastPart).replaceAll('-', ' ')
}
